import { AppConstants } from '@/helpers/app.constants';
import { PropertyHelper } from '@/helpers/property.helper';
import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PropertiesService, PropertyRoom, RealProperty } from '@eemo/api-client';

import { MatButtonModule } from '@angular/material/button';
import { InputNullValueDirective } from '../../extensions/inputNullValueDirective';
import { InputDecimalValueDirective } from '../../extensions/inputDecimalValueDirective';
import { InputUnitDirective } from '../../extensions/inputUnitDirective';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

export class PropertyRoomDialogData {
  prop: RealProperty;
  room?: PropertyRoom;
  edition = false;
}

@Component({
    selector: 'app-property-room-dialog',
    templateUrl: './property-room-dialog.component.html',
    styleUrls: ['./property-room-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, NgIf, MatInputModule, InputTrimDirective, InputUnitDirective, InputDecimalValueDirective, InputNullValueDirective, MatButtonModule]
})
export class PropertyRoomDialogComponent implements OnInit {
  roomForm: UntypedFormGroup;
  dialogTitle: string;
  formSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyRoomDialogData,
    private propertyService: PropertiesService,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    public propertyHelper: PropertyHelper,
    public dialogRef: MatDialogRef<PropertyRoomDialogComponent>
  ) {
    this.dialogTitle = this.data.edition ? 'Modifier la pièce' : 'Créer une pièce';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.roomForm.get(field);
  }

  ngOnInit() {
    this.roomForm = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(50)]],
      type: [null, Validators.required],
      surface: [null, [Validators.pattern(AppConstants.FORM_PATTERN_POSITIVE_DECIMAL), Validators.min(0)]],
      level: [null, [Validators.pattern(AppConstants.FORM_PATTERN_INTEGER)]],
      exposure: [null],
      openingTypes: [[]]
    });

    this.f('type').valueChanges.subscribe((value) => {
      if (!this.f('name').value) {
        this.fillName(this.propertyHelper.getPropertyRoomTypeName(value));
      }
    });

    if (this.data.room) {
      this.roomForm.patchValue(this.data.room);
    }
  }

  onSubmit() {
    if (this.roomForm.valid) {
      this.formSubmitting = true;
      if (this.data.edition) {
        this.propertyService
          .updateRealPropertyRoom(this.data.prop.uid, this.data.room.uid, this.roomForm.value)
          .subscribe(
            (result) => {
              this.dialogRef.close(true);
              this.alertService.success('Mise à jour effectuée');
            },
            (err: HttpErrorResponse) => {
              this.dialogRef.close();
            }
          );
      } else {
        this.propertyService.createRealPropertyRoom(this.data.prop.uid, this.roomForm.value).subscribe(
          (createdId) => {
            this.dialogRef.close(createdId);
            this.alertService.success('Création effectuée');
          },
          (err: HttpErrorResponse) => {
            this.dialogRef.close();
          }
        );
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  fillName(value: string): void {
    this.f('name').setValue(value);
  }
}
